//
//   Returns the max height of a set of elements
//
//////////////////////////////////////////////////////////////////////
const maxHeight = (e) => {
  return Math.max.apply(null, e.map(function () {
    return $(this).outerHeight(true);
  }).get());
};
export default maxHeight;